import { render, staticRenderFns } from "./Tema.comp.vue?vue&type=template&id=8d39d1f2&scoped=true&"
import script from "./Tema.comp.vue?vue&type=script&lang=js&"
export * from "./Tema.comp.vue?vue&type=script&lang=js&"
import style0 from "./Tema.comp.vue?vue&type=style&index=0&id=8d39d1f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d39d1f2",
  null
  
)

export default component.exports